import React from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import { toast } from 'react-toastify';
import managePagesServices from "../../services/managePages.services";
import { ManagePageSchema } from "../../schema/ManagePagesSchema";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const initialValues = {
    pageTitle: '',
    pageUrl:'',
    pageDescription: '',
    pageType:1
}

const ManageForm = ({ toggle, isAddMode, getData, selectedRow }) => {
    const savedValues = {
        pageTitle: selectedRow?.pageTitle,
        pageUrl: selectedRow?.pageUrl,
        pageDescription: selectedRow?.pageDescription,
    }
    const onSubmit = async (values) => {
        if (isAddMode === 'Add') {
            const menuTitleArray = values.pageTitle.split(" ");
            values.pageUrl= menuTitleArray.join("-").toLowerCase();
            const result = await managePagesServices.creatApi(values);
            if (result.data.status === true) {
                // actions.resetForm();
                getData()
                toggle()
                toast.success('Record added successfully', { toastId: 'registration_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
            }
        } else {
            const menuTitleArray = values.pageTitle.split(" ");
            values.pageUrl= menuTitleArray.join("-").toLowerCase();
            console.log('vall', values)
            const result = await managePagesServices.updateApi(selectedRow?._id, values)
            if (result.data.status === true) {
                // actions.resetForm();
                getData()
                toggle()
                toast.success('Record updated successfully', { toastId: 'update_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
            }
        }
    }
    return (
        <React.Fragment>
            <Formik
                initialValues={isAddMode === 'Add' ? initialValues : savedValues}
                validationSchema={ManagePageSchema('add')}
                onSubmit={onSubmit}
                enableReinitialize
            >
               {({ setFieldValue, values }) => ( <Form>
                    <ModalHeader toggle={toggle}>
                        <div className="card-title d-flex align-items-center">
                            <div>
                                <i className="bx bxs-user me-1 font-22 text-primary" />
                            </div>
                            <h5 className="mb-0 text-primary">{isAddMode === 'Add' ? 'Add New Menu' : 'Update Menu'}</h5>
                        </div>
                    </ModalHeader>
                    <ModalBody className="">
                        <Col md={12}>
                            <div className="row g-3" >
                                <div className="col-md-12">
                                    <label htmlFor="pageTitle" className="form-label">
                                        Menu Title
                                    </label>
                                    <Field type="text" className="form-control" id="pageTitle" name='pageTitle'
                                    />
                                    <ErrorMessage name='pageTitle' component={TextError} />
                                </div>
                                {/* <div className="col-md-12">
                                    <label htmlFor="pageUrl" className="form-label"> Page Url </label>
                                    <Field as='select' className='form-select' id="pageUrl" name="pageUrl">
                                        <option  disabled value="">Select Page Url</option>
                                        <option value="home">Home</option>
                                        <option value="about">About</option>
                                        <option value="services">Services</option>
                                        <option value="contact">Contact</option>
                                    </Field>
                                    <ErrorMessage name="city" component={TextError} />
                                </div> */}
                                {/* <div className="col-md-12">
                                    <label htmlFor="pageDescription" className="form-label">
                                        Menu Description
                                    </label>
                                    
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={values.pageDescription}
                                        onReady={editor => {
                                            // You can store the "editor" and use when it is needed.
                                            console.log('Editor is ready to use!', editor);
                                        }}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            console.log({ event, editor, data });
                                            setFieldValue("pageDescription", data);
                                        }}
                                        onBlur={(event, editor) => {
                                            console.log('Blur.', editor);
                                        }}
                                        onFocus={(event, editor) => {
                                            console.log('Focus.', editor);
                                        }}
                                    />
                                    <ErrorMessage name='pageDescription' component={TextError} />
                                </div> */}

                            </div>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={toggle}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary px-5">
                            {isAddMode === "Add" ? "Save" : "Update"}
                        </button>
                    </ModalFooter>
                </Form>
               )}
            </Formik>
        </React.Fragment>
    );
}

export default ManageForm;